import React from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";

import * as Yup from "yup";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import "./Subscription.scss";
import { PageSubHeader } from "components/CommonLayouts/PageSubHeader";
import Footer from "components/VerticalLayout/Footer";
import { charactersWithSpaces } from "helpers/validations/regex";

function ViewSubscription() {
  const navigate = useNavigate();

  const initialValues = {
    packageType: "Standard",
    organizationName: "",
    country: "",
    vatNumber: "",
    pan: "",
    tan: "",
    email: "",
    password: "",
    amountPaid: "",
    status: 1,
  };
  const validation = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object({
      packageType: Yup.string().required("Package Required"),
      organizationName: Yup.string().required("Please enter organization name").matches(charactersWithSpaces, "Organization Name should only contain characters"),
      country: Yup.string().required("Please select a country").matches(charactersWithSpaces, "Country Name should only contain characters"),
      vatNumber: Yup.string().required("Please enter VAT/registration number"),
      pan: Yup.string().nullable(), // PAN is optional, so no requirement
      tan: Yup.string().nullable(), // TAN is optional, so no requirement
      email: Yup.string()
        .email("Must be a valid email")
        .required("Please enter email"),
      password: Yup.string()
        .required("Password is required")
        .min(8, "Password is too short - should be 8 characters minimum.")
        .matches(
          /^(?=.*[a-z])/,
          "Password must contain at least one lowercase letter."
        )
        .matches(
          /^(?=.*[A-Z])/,
          "Password must contain at least one uppercase letter."
        )
        .matches(/^(?=.*\d)/, "Password must contain at least one number.")
        .matches(
          /^(?=.*[!@#$%^&*()\-_=+{};:,<.>])/,
          "Password must contain at least one special character."
        ),
      amountPaid: Yup.number()
        .required("Please enter the amount paid")
        .positive("Amount must be a positive number"),
      status: Yup.string().required("Please select status"),
    }),
    onSubmit: async (values) => {
      // console.log(values);
    },
  });

  return (
    <>
      <div className="page-content">
        <Container fluid={true} style={{ padding: "0px", gap: "10px" }}>
          <PageSubHeader
            heading={"Subscription"}
            routePath={"Home"}
            pageName={"Subscription"}
          />
          <Row className="p-4">
            <Col>
              <Card>
                <CardBody>
                  <Form
                    className="row g-3 needs-validation py-4"
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <Row>
                      <Row className="py-3">
                        <FormGroup className="mb-3">
                          <Label>
                            Package Type<span className="text-danger">*</span>
                          </Label>
                          <div className="subscription-grid">
                            <label className="subscription-card">
                              <Input
                                name="packageType"
                                className="subscription-radio"
                                type="radio"
                                value="Standard"
                                onChange={validation.handleChange}
                                checked={
                                  validation.values.packageType === "Standard"
                                }
                              />
                              <span className="subscription-plan-details">
                                <span className="subscription-plan-type">
                                  Standard
                                </span>
                                <span className="subscription-plan-cost">
                                  $0
                                  <span className="subscription-slash">/</span>
                                  <span className="subscription-plan-cycle">
                                    mo
                                  </span>
                                </span>
                                <span>1 team member</span>
                                <span>100 GB/mo</span>
                                <span>1 concurrent build</span>
                              </span>
                            </label>

                            <label className="subscription-card">
                              <Input
                                name="packageType"
                                className="subscription-radio"
                                type="radio"
                                value="Premium"
                                onChange={validation.handleChange}
                                checked={
                                  validation.values.packageType === "Premium"
                                }
                              />
                              {/* <span className="subscription-hidden-visually">
                                Premium - $50 per month, 5 team members, 500 GB per
                                month, 5 concurrent builds
                              </span> */}
                              <span
                                className="subscription-plan-details"
                                aria-hidden="true"
                              >
                                <span className="subscription-plan-type">
                                  Premium
                                </span>
                                <span className="subscription-plan-cost">
                                  $50
                                  <span className="subscription-slash">/</span>
                                  <span className="subscription-plan-cycle">
                                    mo
                                  </span>
                                </span>
                                <span>5 team members</span>
                                <span>500 GB/mo</span>
                                <span>5 concurrent builds</span>
                              </span>
                            </label>

                            <label className="subscription-card">
                              <Input
                                name="packageType"
                                className="subscription-radio"
                                type="radio"
                                value="Enterprise"
                                onChange={validation.handleChange}
                                checked={
                                  validation.values.packageType === "Enterprise"
                                }
                              />
                              {/* <span className="subscription-hidden-visually">
                                Enterprise - $200 per month, 5+ team members, 1000
                                GB per month, Unlimited builds
                              </span> */}
                              <span
                                className="subscription-plan-details"
                                aria-hidden="true"
                              >
                                <span className="subscription-plan-type">
                                  Enterprise
                                </span>
                                <span className="subscription-plan-cost">
                                  $200
                                  <span className="subscription-slash">/</span>
                                  <span className="subscription-plan-cycle">
                                    mo
                                  </span>
                                </span>
                                <span>5+ team members</span>
                                <span>1000 GB/mo</span>
                                <span>Unlimited builds</span>
                              </span>
                            </label>
                          </div>
                        </FormGroup>
                      </Row>

                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label>
                            Organization Name
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="organizationName"
                            type="text"
                            className="form-control"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.organizationName || ""}
                            invalid={
                              validation.touched.organizationName &&
                              validation.errors.organizationName
                                ? true
                                : false
                            }
                          />
                          {validation.touched.organizationName &&
                          validation.errors.organizationName ? (
                            <FormFeedback type="invalid">
                              {validation.errors.organizationName}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label>
                            Country<span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="country"
                            type="text"
                            className="form-control"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.country || ""}
                            invalid={
                              validation.touched.country &&
                              validation.errors.country
                                ? true
                                : false
                            }
                          />
                          {validation.touched.country &&
                          validation.errors.country ? (
                            <FormFeedback type="invalid">
                              {validation.errors.country}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label>
                            VAT/Registration Number
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="vatNumber"
                            type="text"
                            className="form-control"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.vatNumber || ""}
                            invalid={
                              validation.touched.vatNumber &&
                              validation.errors.vatNumber
                                ? true
                                : false
                            }
                          />
                          {validation.touched.vatNumber &&
                          validation.errors.vatNumber ? (
                            <FormFeedback type="invalid">
                              {validation.errors.vatNumber}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label>PAN</Label>
                          <Input
                            name="pan"
                            type="text"
                            className="form-control"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.pan || ""}
                            invalid={
                              validation.touched.pan && validation.errors.pan
                                ? true
                                : false
                            }
                          />
                          {validation.touched.pan && validation.errors.pan ? (
                            <FormFeedback type="invalid">
                              {validation.errors.pan}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label>TAN</Label>
                          <Input
                            name="tan"
                            type="text"
                            className="form-control"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.tan || ""}
                            invalid={
                              validation.touched.tan && validation.errors.tan
                                ? true
                                : false
                            }
                          />
                          {validation.touched.tan && validation.errors.tan ? (
                            <FormFeedback type="invalid">
                              {validation.errors.tan}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label>
                            Email<span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="email"
                            type="email"
                            className="form-control"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.email || ""}
                            invalid={
                              validation.touched.email &&
                              validation.errors.email
                                ? true
                                : false
                            }
                          />
                          {validation.touched.email &&
                          validation.errors.email ? (
                            <FormFeedback type="invalid">
                              {validation.errors.email}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label>
                            Password<span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="password"
                            type="password"
                            className="form-control"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.password || ""}
                            invalid={
                              validation.touched.password &&
                              validation.errors.password
                                ? true
                                : false
                            }
                          />
                          {validation.touched.password &&
                          validation.errors.password ? (
                            <FormFeedback type="invalid">
                              {validation.errors.password}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label>
                            Amount Paid<span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="amountPaid"
                            type="text"
                            className="form-control"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.amountPaid || ""}
                            invalid={
                              validation.touched.amountPaid &&
                              validation.errors.amountPaid
                                ? true
                                : false
                            }
                          />
                          {validation.touched.amountPaid &&
                          validation.errors.amountPaid ? (
                            <FormFeedback type="invalid">
                              {validation.errors.amountPaid}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label>
                            Status<span className="text-danger">*</span>
                          </Label>
                          <Input
                            type="select"
                            name="status"
                            className="form-select"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.status || 1}
                            invalid={validation.errors.status ? true : false}
                          >
                            <option value={1}>Active</option>
                            <option value={0}>Inactive</option>
                          </Input>
                          {validation.errors.status ? (
                            <FormFeedback type="invalid">
                              {validation.errors.status}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <Footer save={validation.handleSubmit} />
    </>
  );
}

export default ViewSubscription;
